<!--
 * @Description: 新闻中心
 * @Author: mileS
 * @Date: 2019-08-07 10:14:46
 * @LastEditTime: 2020-06-10 16:37:50
 * @LastEditors: mileS
 -->
<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>
